import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ImageGallery from 'react-image-gallery';
import classnames from 'classnames';

import { Container } from 'reactstrap';

import {
  getFiles,
  setFilesEnd,
} from '../../actions/Files';

import PageSectionHeader from './SectionHeader';

const PageSectionCollectionSlider = ({ dispatch, section, page }) => {
  let imageGallery = useRef();
  const history = useHistory();

  if (section.collections.length === 0) {
    return null;
  }

  const photos = section.collections[0].files ? section.collections[0].files.map(file => (
    {
      original: file.urls.featured,
      thumbnail: file.urls.thumbnail,
      url: {
        pathname: `/files/${file.uuid}`,
        state: {
          modal: true,
        },
      },
    }
  )) : [];

  return (
    <div className="custom-page-section landing-collection-slider">
      <Container>
        <PageSectionHeader section={section} />
        <ImageGallery
          additionalClass={classnames({ 'slider-clickable': page.options.page_type === 'internal' })}
          ref={(ref) => { imageGallery = ref; }}
          items={photos}
          showPlayButton={false}
          showFullscreenButton={false}
          showThumbnails={photos.length > 1}
          onClick={() => {
            if (page.options.page_type !== 'internal') {
              return;
            }

            if (photos[imageGallery.getCurrentIndex()]) {
              dispatch(getFiles(section.collections[0].files));
              dispatch(setFilesEnd(true));
              history.push(photos[imageGallery.getCurrentIndex()].url);
            }
          }}
        />
      </Container>
    </div>
  );
};

PageSectionCollectionSlider.propTypes = {
  dispatch: PropTypes.func.isRequired,
  section: PropTypes.object.isRequired,
  page: PropTypes.object.isRequired,
};

export default connect()(PageSectionCollectionSlider);
